/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_View_DeductionsInputs */

const en_cargos_view_deductions = /** @type {(inputs: Cargos_View_DeductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Deductions`)
};

const es_cargos_view_deductions = /** @type {(inputs: Cargos_View_DeductionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver deducciones`)
};

/**
* | output |
* | --- |
* | "View Deductions" |
*
* @param {Cargos_View_DeductionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_view_deductions = /** @type {((inputs?: Cargos_View_DeductionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_View_DeductionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_view_deductions(inputs)
	return es_cargos_view_deductions(inputs)
});